import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { ScopeDefinitionFilters } from "./ScopeDefinitionFilters";
import { OriginRegionFilters } from "./OriginRegionFilters";
import { OtherCriteriaFilters } from "./OtherCriteriaFilters";
import { useFetchSelectedFiltersForTtProtection } from "./Hooks/useFetchSelectedFiltersForTtProtection";
import { TTProtection } from "../../TTProtection";

export const TtProtectionFilterForm = () => {
  const { getValues } = useFormContext<TTProtection>();
  const { data: selectedFilters } = useFetchSelectedFiltersForTtProtection(getValues("Id"));

  return (
    <Grid container>
      <Grid item xs={12}>
        <ScopeDefinitionFilters />
      </Grid>
      <Grid item xs={12}>
        <OriginRegionFilters selectedFilters={selectedFilters} />
      </Grid>
      <Grid item xs={12}>
        <OtherCriteriaFilters selectedFilters={selectedFilters} />
      </Grid>
    </Grid>
  );
};
